<template>
  <div class="game-room-page">
    <img src="/static/image/new/Liuhe/room-head-bg.png" class="head-bg-img" alt="">
    <div style="position: relative; z-index: 2;">
      <div class="head-area">
        <div class="leftImg">
          <img @click="back" src="/static/image/icon-jiantou@2x.eb0b501e01e95b720b727b63a23960e3.png" class="top_back">
        </div>
        <div class="head_text">
<!--          <span class="title">{{ title }}</span>-->
          <span class="title">{{ title }}({{$t('初级')}})</span>
        </div>
        <span class="right_menu">
    </span>
      </div>
      <div class="lottery-box-bg">
        <div class="lottery-box">
          <div class="top">
            <div class="top-left">
              <div class="lottery-period">{{ $t('第') }}{{sequence_info.sequencenum + 1}}{{ $t('期') }}</div>
            </div>
            <div class="top-right">

            </div>
          </div>
          <div class="bottom">
            <div class="count-down">
              <div class="hours-box">{{ hours }}</div>
              <div class="minute-box">{{ minute }}</div>
              <div class="second-box">{{ second }}</div>
              <span class="status" v-if="room_info.youxi">{{ totalSeconds > Number(room_info.youxi.qs_start_time) ?  $t('开盘中') : $t('已封盘')}}</span>
            </div>
            <div class="user-money">
              <div> {{ $t('我的余额') }}</div>
              <span class="money">{{ money }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="lottery-results-box">
        <div class="results-title">
          <span>{{ $t('第') }}{{sequence_info.sequencenum}}{{ $t('期') }}</span>
          <span>{{formatDate(sequence_info.addtime, 'seconds') }}</span>
        </div>
        <div class="lottery-results" v-if="sequence_info.outcome_arr">
          <div class="num-item" v-for="(item,index) in sequence_info.outcome_arr" v-if="index < sequence_info.outcome_arr.length - 1">
            <div :class="['num', getNumColor(item)]">{{ item }}</div>
            <div class="num-type">{{ getNumText(item) }}</div>
          </div>
          <div class="symbol">+</div>
          <div class="num-item">
            <div :class="['num', getNumColor(sequence_info.outcome_arr[sequence_info.outcome_arr.length-1])]">{{ sequence_info.outcome_arr[sequence_info.outcome_arr.length-1] }}</div>
            <div class="num-type">{{ getNumText(sequence_info.outcome_arr[sequence_info.outcome_arr.length-1]) }}</div>
          </div>
        </div>
        <div class="nav-list">
          <div :class="{'nav-item': true, 'active': nav_type === 0}" @click="clickNaTab(0, '')">
            <img src="/static/image/new/Liuhe/msg-icon-white.png" v-if="nav_type === 0"  alt="">
            <img src="/static/image/new/Liuhe/msg-icon-gray.png"  v-else  alt="">
          </div>
          <div :class="{'nav-item': true, 'active': nav_type === item.id}" v-for="(item) in nav_list" :key="item.id" @click="clickNaTab(item.id, item.path)">{{item.name}}</div>
          <div :class="{'nav-item': true, 'active': nav_type === 10}" @click="clickNaTab(10, '')">
            <img src="/static/image/new/Liuhe/money-icon.png"  alt="">
          </div>
        </div>
      </div>

    </div>
    <div class="content">
      <!--  开奖下拉框    -->
      <div class="list_drop_box" v-if="isDropList">
        <div class="table-head">
          <div class="td">{{ $t('期号') }}</div>
          <div class="td">{{ $t('号码') }}</div>
          <div class="td">{{ $t('总和') }}</div>
          <div class="td">{{ $t('总和两面') }}</div>
        </div>
        <div class="recode-table">
          <div class="table-list">
            <div class="tr" v-for="(item,index) in trend_list" :key="index">
              <div class="td">
                {{ $t('第') }}<span style="margin: 0 .1rem;">{{ item.sequencenum }}</span>{{ $t('期') }}
              </div>
              <div class="td">
                <div class="num-box">
                  <div class="num blue-bg">{{ item.outcome_arr[0] }}</div>+
                  <div class="num blue-bg">{{ item.outcome_arr[1] }}</div>+
                  <div class="num blue-bg">{{ item.outcome_arr[2] }}</div>=
                  <div :class="['num', item.outcome_arr[3] >= 14 ? 'red-bg' : 'green-bg']">{{ item.outcome_arr[3] }}</div>
                </div>
              </div>
              <div class="td">
                <div class="sum-info">
                  <span :class="[item.outcome_arr[3] >= 14 ? 'red-color' : 'blue-color']">{{item.outcome_arr[3] >= 14 ? $t('大') : $t('小')}}</span>
                  <span :class="[item.outcome_arr[3] % 2 === 1 ? 'blue-color' : 'red-color']">{{item.outcome_arr[3] % 2 === 1 ? $t('单') : $t('双')}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-else>
         <!--  投注区  -->
        <div :class="{'game-type-container': true, 'game-type-container-modal': isPageModal}" v-if="nav_type === 1 || isPageModal">
          <div class="game-type-main">
            <div class="game-type-nav">
              <div :class="{'nav-item': true, 'active': item.type === game_type_index}" v-for="(item,index) in game_type_nav" :key="index" @click="game_type_index = item.type">{{item.name}}</div>
            </div>
            <div class="game-type-content"  v-if="room_info.systemconfig">
              <div class="game-num-list" v-if="game_type_index === 1">
                <div class="game-num-title">{{ $t('特码') }}</div>
                <div class="game-num-row">
                  <template  v-for="i in 49">
                    <div :class="{'game-num': true, 'active': game_type_val.includes(''+ i )}" @click="selectGameType('' + i)">
                      <div class="label">{{ i }}</div>
                      <div class="value">{{ room_info.systemconfig.number['odds_'+i] }}</div>
                    </div>
                  </template>



                </div>
              </div>
              <div class="game-num-list" v-else-if="game_type_index === 2">
                <div class="game-num-title">{{ $t('特肖') }}</div>
                <div class="game-num-row">
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特鼠')}" @click="selectGameType('特鼠')">
                    <div class="label">{{ $t('特鼠') }}</div>
                    <div class="value">{{ room_info.systemconfig.tx_shu.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特牛')}" @click="selectGameType('特牛')">
                    <div class="label">{{ $t('特牛') }}</div>
                    <div class="value">{{ room_info.systemconfig.tx_niu.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特虎')}" @click="selectGameType('特虎')">
                    <div class="label">{{ $t('特虎') }}</div>
                    <div class="value">{{ room_info.systemconfig.tx_hu.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特兔')}" @click="selectGameType('特兔')">
                    <div class="label">{{ $t('特兔') }}</div>
                    <div class="value">{{ room_info.systemconfig.tx_tu.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特龙')}" @click="selectGameType('特龙')">
                    <div class="label">{{ $t('特龙') }}</div>
                    <div class="value">{{ room_info.systemconfig.tx_long.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特蛇')}" @click="selectGameType('特蛇')">
                    <div class="label">{{ $t('特蛇') }}</div>
                    <div class="value">{{ room_info.systemconfig.tx_she.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特马')}" @click="selectGameType('特马')">
                    <div class="label">{{ $t('特马') }}</div>
                    <div class="value">{{ room_info.systemconfig.tx_ma.odds }}</div>
                  </div>

                  <div :class="{'game-num': true, 'active': game_type_val.includes('特羊')}" @click="selectGameType('特羊')">
                    <div class="label">{{ $t('特羊') }}</div>
                    <div class="value">{{ room_info.systemconfig.tx_yang.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特猴')}" @click="selectGameType('特猴')">
                    <div class="label">{{ $t('特猴') }}</div>
                    <div class="value">{{ room_info.systemconfig.tx_hou.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特鸡')}" @click="selectGameType('特鸡')">
                    <div class="label">{{ $t('特鸡') }}</div>
                    <div class="value">{{ room_info.systemconfig.tx_ji.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特狗')}" @click="selectGameType('特狗')">
                    <div class="label">{{ $t('特狗') }}</div>
                    <div class="value">{{ room_info.systemconfig.tx_gou.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特猪')}" @click="selectGameType('特猪')">
                    <div class="label">{{ $t('特猪') }}</div>
                    <div class="value">{{ room_info.systemconfig.tx_zhu.odds }}</div>
                  </div>
                </div>

              </div>
              <div class="game-num-list" v-else-if="game_type_index === 3">
                <div class="game-num-title">{{ $t('平肖') }}</div>
                <div class="game-num-row">
                  <div :class="{'game-num': true, 'active': game_type_val.includes('鼠')}" @click="selectGameType('鼠')">
                    <div class="label">{{ $t('鼠') }}</div>
                    <div class="value">{{ room_info.systemconfig.ptx_shu.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('牛')}" @click="selectGameType('牛')">
                    <div class="label">{{ $t('牛') }}</div>
                    <div class="value">{{ room_info.systemconfig.ptx_niu.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('虎')}" @click="selectGameType('虎')">
                    <div class="label">{{ $t('虎') }}</div>
                    <div class="value">{{ room_info.systemconfig.ptx_hu.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('兔')}" @click="selectGameType('兔')">
                    <div class="label">{{ $t('兔') }}</div>
                    <div class="value">{{ room_info.systemconfig.ptx_tu.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('龙')}" @click="selectGameType('龙')">
                    <div class="label">{{ $t('龙') }}</div>
                    <div class="value">{{ room_info.systemconfig.ptx_long.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('蛇')}" @click="selectGameType('蛇')">
                    <div class="label">{{ $t('蛇') }}</div>
                    <div class="value">{{ room_info.systemconfig.ptx_she.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('马')}" @click="selectGameType('马')">
                    <div class="label">{{ $t('马') }}</div>
                    <div class="value">{{ room_info.systemconfig.ptx_ma.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('羊')}" @click="selectGameType('羊')">
                    <div class="label">{{ $t('羊') }}</div>
                    <div class="value">{{ room_info.systemconfig.ptx_yang.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('猴')}" @click="selectGameType('猴')">
                    <div class="label">{{ $t('猴') }}</div>
                    <div class="value">{{ room_info.systemconfig.ptx_hou.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('鸡')}" @click="selectGameType('鸡')">
                    <div class="label">{{ $t('鸡') }}</div>
                    <div class="value">{{ room_info.systemconfig.ptx_ji.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('狗')}" @click="selectGameType('狗')">
                    <div class="label">{{ $t('狗') }}</div>
                    <div class="value">{{ room_info.systemconfig.ptx_gou.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('猪')}" @click="selectGameType('猪')">
                    <div class="label">{{ $t('猪') }}</div>
                    <div class="value">{{ room_info.systemconfig.ptx_long.odds }}</div>
                  </div>
                </div>
              </div>
              <div class="game-num-list" v-else-if="game_type_index === 4">
                <div class="game-num-title">{{ $t('类型') }}</div>
                <div class="game-num-row">
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特码蓝波')}" @click="selectGameType('特码蓝波')">
                    <div class="label">{{ $t('蓝波') }}</div>
                    <div class="value">{{ room_info.systemconfig.tmlan.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特码绿波')}" @click="selectGameType('特码绿波')">
                    <div class="label">{{ $t('绿波') }}</div>
                    <div class="value">{{ room_info.systemconfig.tmlv.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('特码红波')}" @click="selectGameType('特码红波')">
                    <div class="label">{{ $t('红波') }}</div>
                    <div class="value">{{ room_info.systemconfig.tmhong.odds }}</div>
                  </div>
                </div>
              </div>
              <div class="game-num-list" v-else-if="game_type_index === 5">

                <div class="game-num-title">{{ $t('大小单双') }}</div>
                <div class="game-num-row">
                  <div :class="{'game-num': true, 'active': game_type_val.includes('大') }" @click="selectGameType('大')">
                    <div class="label">{{ $t('大') }}</div>
                    <div class="value">{{ room_info.systemconfig.tmda.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('小')}" @click="selectGameType('小')">
                    <div class="label">{{ $t('小') }}</div>
                    <div class="value">{{ room_info.systemconfig.tmxiao.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('单')}" @click="selectGameType('单')">
                    <div class="label">{{ $t('单') }}</div>
                    <div class="value">{{ room_info.systemconfig.tmdan.odds }}</div>
                  </div>
                  <div :class="{'game-num': true, 'active': game_type_val.includes('双')}" @click="selectGameType('双')">
                    <div class="label">{{ $t('双') }}</div>
                    <div class="value">{{ room_info.systemconfig.tmshuang.odds }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="background: linear-gradient(to bottom, #191e21, #151a1b)">
            <div class="game-type-num">
              <div class="select-num-box">
                <div :class="{'num': true, 'active': item == game_type_price}" v-for="(item,index) in game_money_list" :key="item" @click="game_type_price = item">{{item}}</div>
                <div class="num">
                  <img src="/static/image/new/Liuhe/edit-icon.png" class="edit-btn" @click="showEditMoney = true" alt="">
                </div>

              </div>

              <div class="send-input">
                <input type="Number" :placeholder="$t('快捷投注')" v-model="num_val">
              </div>
            </div>
            <div class="game-type-btn">
              <div class="submit-tips">{{ $t('已选') }}<span class="blue-color">{{game_type_val.length}}</span>{{ $t('项') }}，{{ $t('需支付') }} <span class="blue-color">{{ game_type_val.length * (Number(num_val) > 0 ? Number(num_val) : Number(game_type_price))}}</span></div>

              <div style="display: flex;">
                <div class="clean-btn btn" @click="clearSendInput()">
                  <img src="/static/image/new/Liuhe/del-icon.png" class="del-icon" alt="">
                </div>
                <div class="submit-btn btn" @click="sendBetMsg()">
                  {{ $t('确认投注') }}
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="msg-container" v-if="nav_type === 0">
          <div class="msg-list" ref="scrollContainer">
            <template v-for="(item,index) in chat_list">
              <template v-if="item.role == 1 && item.room === room">
                <template v-if="item.distinguish == 1">
                  <div class="msg-item" v-if="item.userid == room_info.userid">
                    <div class="left"></div>
                    <div class="right">
                      <div class="msg-content">
                        <div class="msg-text" v-html="item.content"></div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="item.distinguish == 0 || (item.distinguish == 2 && item.userid == room_info.userid)">
                  <div :class="{'msg-item': true, 'self-msg-item': item.userid === room_info.userid}">
                    <div class="left">
                      <img class="avatar" src="/static/image/new/game/logo.png?v=1" alt="">
                    </div>
                    <div class="right">
                      <div class="msg-name">
                        <span>[{{ $t('投注成功') }}]</span>
                        <span style="color: #fff; font-size: .27rem;margin: 0 .1rem;">{{ formatDate(item.addtime, 'seconds') }}</span>
                      </div>
                      <div class="msg-content">
                        <div class="msg-text">
                          {{ $t('期号') }}：{{ item.sequencenum }}
                        </div>
                        <div class="msg-text">
                          {{ $t('用户') }}：{{ $t(item.username) }}
                        </div>
                        <div class="msg-text">
                          {{ $t('投注') }}：<span v-html="item.content"></span>
                        </div>
                        <div class="msg-text">
                          {{ $t('时间') }}：{{  formatDate(item.addtime, 'seconds') }}
                        </div>                         </div>
                    </div>
                  </div>
                </template>
              </template>
              <div :class="{'msg-item': true, 'self-msg-item': item.userid === room_info.userid}" v-else-if="item.userid == room_info.userid && item.room == room">
                <div class="left">
                  <img class="avatar" :src="img_link + item.headimgurl" v-if="item.headimgurl" alt="">
                  <img class="avatar" src="/static/image/new/game/default.png" v-else alt="">
                </div>
                <div class="right">
                  <div class="msg-name">
                    <span>{{ $t(item.username)}}</span>
                    <span class="vip-box">
                        <img src="/static/image/new/game/vip1.png" class="vip-icon" alt="">
                        VIP1
                    </span>
                  </div>
                  <div class="msg-content">
                    <div class="msg-time">{{ formatDate(item.addtime, 'seconds') }}</div>
                    <div class="msg-text" v-html="item.content"></div>
                  </div>
                </div>
              </div>
              <div :class="{'msg-item': true, 'self-msg-item': item.userid === room_info.userid}" v-else>
                <div class="left">
                  <img class="avatar" :src="img_link + item.headimgurl" v-if="item.headimgurl" alt="">
                  <img class="avatar" src="/static/image/new/game/default.png" v-else alt="">
                </div>
                <div class="right">
                  <div class="msg-name">
                    <span>[{{ $t('投注成功') }}]</span>
                    <span style="color: #fff; font-size: .27rem;margin: 0 .1rem;" v-if="item.role === 1">{{ formatDate(item.addtime, 'seconds') }}</span>
                    <span class="vip-box" v-else>
                        <img src="/static/image/new/game/vip1.png" class="vip-icon" alt="">
                        VIP1
                    </span>
                  </div>
                  <div class="msg-content">
                    <div class="msg-text">
                      {{ $t('期号') }}：{{ item.sequencenum }}
                    </div>
                    <div class="msg-text">
                      {{ $t('用户') }}：{{ $t(item.username) }}
                    </div>
                    <div class="msg-text">
                      {{ $t('投注') }}：<span v-html="item.content"></span>
                    </div>
                    <div class="msg-text">
                      {{ $t('时间') }}：{{  formatDate(item.addtime, 'seconds') }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="footer">
            <div class="bet-box">
              <img src="static/image/new/Liuhe/send-more.png" @click="isPageModal = true" class="send-more" alt="">
              <div class="bet-input">
                <input type="text" :placeholder="$t('请输入')+'...'" v-model="send_val">
              </div>
              <div class="bet-btn" @click="sendMessage">{{ $t('下注') }}</div>
            </div>
          </div>

        </div>
        <!-- 开奖走势   -->
         <div class="record-container" v-else-if="nav_type === 3">
           <div class="table-head">
             <div class="td">{{ $t('期号') }}</div>
             <div class="td">{{ $t('开奖号码') }}</div>
             <div class="td">{{ $t('特码') }}</div>
           </div>
           <div class="recode-table">
             <van-list :finished-text="$t('没有更多了')" offset="300" v-model="loading_trend" :finished="trend_page > trend_total_page" @load="getTrendList" v-if="trend_list.length > 0">
               <div class="table-list">
                 <div class="tr" v-for="(item,index) in trend_list" :key="index">
                   <div class="td">
                     <div class="sequencenum">{{ item.sequencenum }}</div>
                   </div>
                   <div class="td">
                     <div class="num-box">
                       <div class="num-item" v-for="(num, numIndex) in item.outcome_arr" v-if="numIndex < item.outcome_arr.length - 1">
                         <div :class="['num', getNumColor(num)]">{{ num }}</div>
                         <div class="num-type">{{ getNumText(num) }}</div>
                       </div>
                       <div class="symbol">+</div>
                       <div class="num-item">
                         <div :class="['num', getNumColor(item.outcome_arr[item.outcome_arr.length-1])]">{{ item.outcome_arr[item.outcome_arr.length-1] }}</div>
                         <div class="num-type">{{ getNumText(item.outcome_arr[item.outcome_arr.length-1]) }}</div>
                       </div>
                     </div>
                   </div>
                   <div class="td">
                     <div class="last-text">
                       <div class="text">{{ item.outcome_arr[item.outcome_arr.length-1] }}</div>
                       <div class="text">{{ getNumText(item.outcome_arr[item.outcome_arr.length-1]) }}</div>
                       <div class="text">
                         <div :class="['num', getNumColor(item.outcome_arr[item.outcome_arr.length-1])]">{{ getNumWave(item.outcome_arr[item.outcome_arr.length-1]) }}</div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </van-list>
           </div>

         </div>
         <!-- 开奖历史   -->
         <div class="history-container" v-else-if="nav_type === 6">
           <van-list :finished-text="$t('没有更多了')" offset="100" v-model="loading_history" :finished="history_page > history_total_page" @load="getHistoryList" v-if="history_list.length > 0">
             <div class="history-list">
               <div class="history-item" v-for="(item,index) in history_list" :key="index">
                 <div class="item-head">
                   <div class="sequencenum">{{$t('第')}}{{ item.sequencenum }}{{ $t('期') }}</div>
                   <div class="addTime">{{ formatDate(item.addtime, 'seconds') }}</div>
                 </div>
                 <div class="num-box">
                   <div class="num-item" v-for="(num, numIndex) in item.outcome_arr" v-if="numIndex < item.outcome_arr.length - 1">
                     <div :class="['num', getNumColor(num)]">{{ num }}</div>
                     <div class="num-type">{{ getNumText(num) }}</div>
                   </div>
                   <div class="symbol">+</div>
                   <div class="num-item">
                     <div :class="['num', getNumColor(item.outcome_arr[item.outcome_arr.length-1])]">{{ item.outcome_arr[item.outcome_arr.length-1] }}</div>
                     <div class="num-type">{{ getNumText(item.outcome_arr[item.outcome_arr.length-1]) }}</div>
                   </div>
                 </div>
               </div>

             </div>
           </van-list>
         </div>

        <!--  其他记录    -->
        <div class="other-container" v-else-if="nav_type === 10">
          <div class="nav-type-list">
            <div :class="{'item': true, 'active': other_nav_index === 0}" @click="other_nav_index = 0; initBetJson()">{{ $t('进行中') }}</div>
            <div :class="{'item': true, 'active': other_nav_index === 1}" @click="other_nav_index = 1; initBetJson()" >{{ $t('已结束') }}</div>
          </div>
          <div class="type-list-container">
            <van-list :finished-text="$t('没有更多了')" offset="100" v-model="loading_bet" :finished="bet_page > bet_total_page" @load="getBetJson" v-if="bet_list.length > 0">
              <div class="type-list">
                <div class="list-item" v-for="(item,index) in bet_list" :key="index">

                  <div class="item-head">
                    <span class="name">{{ title }}</span>
                    <span>{{ $t('投注') }}: {{ item.bet_money }}</span>
                  </div>
                  <div class="item-content">
                    <div class="table-title">{{ $t('第') }}{{ item.sequencenum }}{{ $t('期') }}</div>
                    <div class="table-list">
                      <div class="tr head-tr">
                        <div class="td">{{ $t('类型') }}</div>
                        <div class="td">{{ $t('下注内容') }}</div>
                        <div class="td">{{ $t('金额') }}</div>
                      </div>
                      <div class="tr">
                        <div class="td">{{ game_list.filter(game => game.type === item.type)[0].name }}</div>
                        <div class="td">{{ item.content }}</div>
                        <div class="td">{{ item.bet_money }}</div>
                      </div>
                      <div class="tr">
                        <div class="td">{{ $t('合计总金额') }}</div>
                        <div class="td">{{ item.bet_money }}</div>
                      </div>
                    </div>
                    <div class="table-foot">
                      <span>{{ $t('房间') }}:</span>
                      <span>{{item.room === 'one' ? $t('初级') : $t('中级') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
            <div class="empy-content" v-else>
              <img src="/static/image/new/Liuhe/list-empy.png" class="icon" alt="">
              <div class="text">{{ $t('什么也没有') }}</div>
            </div>
          </div>

        </div>
      </template>


    </div>
    <div class="overlay-bg" v-if="isPageModal" @click="isPageModal=false"></div>
    <!--  编辑金额弹窗  -->
    <van-popup v-model="showEditMoney" position="bottom" :round="true">
      <div class="edit-money-popup">
        <div class="title-box">
          {{ $t('编辑金额') }}
          <img class="arrow-btn" src="/static/image/new/game/arrow-white.png" @click="showEditMoney = false">
        </div>
        <div class="price-list">
          <div class="price-item" v-for="(item,index) in game_money_list" :key="item">
            <input type="text" v-model="game_money_list[index]">
          </div>
        </div>
        <div class="btn-box">
          <div class="btn default-btn" @click="setDefaultPrice()">{{ $t('恢复默认') }}</div>
          <div class="btn" @click="setAllPrice()">{{ $t('保存') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { formatDate, translateText } from "../../common/utils"
export default {
  name: 'GameRoom',
  data() {
    return {
      img_link: 'https://yuenan6.igusa.co/',
      game_video: 'xamlhc',
      title: '',
      page_size: 20,
      size_list: [20, 50, 100, 200],
      game_list: [],
      nav_type: 1,
      nav_list: [
        {id: 1, name: this.$t('快捷下注'), path: '', isShow: true, icon: ''},
        // {id: 2, name: this.$t('路单区'), path: '/game-trend', isShow: true},
        {id: 3, name: this.$t('开奖走势'), path: '', isShow: true, icon: ''},
        // {id: 5, name: this.$t('开奖验证'), path: '/game-scratch', isShow: false},
        {id: 6, name: this.$t('开奖历史'), path: '', isShow: true, icon: ''},
        // {id: 7, name: this.$t('统计'), path: '/game-statis', isShow: true},
      ],

      isDropList: false,

      game_type_val: [],
      game_type_price: 0,
      num_val: '',
      game_type_index: 1,
      game_type_nav: [
        {
          type: 1,
          name: this.$t('猜特码')
        },
        {
          type: 2,
          name: this.$t('猜特肖')
        },
        {
          type: 3,
          name: this.$t('猜平肖')
        },
        {
          type: 4,
          name: this.$t('猜类型')
        },
        {
          type: 5,
          name: this.$t('大小单双')
        }
      ],
      game_default_money_list: ['10', '50', '100'],
      game_money_list: ['10', '50', '100'],

      totalSeconds: 180, // 倒計時總秒數 (例如 3分鐘)
      hours: '00',
      minute: '00',
      second: '00',
      timer: null,
      time_interval: null,


      // 分页条数弹窗
      isPageModal: false,
      room: 'one',
      money: '0.00',    // 余额
      room_info: {},
      chat_list: [],
      sequence_info: {},

      trend_page: 1,
      trend_total_page: 1,
      trend_list: [],
      loading_trend: false,
      send_val: '',

      history_page: 1,
      history_total_page: 1,
      history_list: [],
      loading_history: false,


      showEditMoney: false,
      timerInter: null,

      other_nav_index: 0,
      loadingMsg: false,

      bet_page: 1,
      bet_total_page: 1,
      bet_list: [],
      bet_info: {},
      loading_bet: false,

      statusInterval: null,
    }
  },

  mounted() {
    const query = this.$route.query;
    if(query.room) {
      this.room = query.room;
    }
    if(query.game_video) {
      this.game_video = query.game_video;
    }

    if(localStorage.getItem('gameEditPrice_Liuhe')) {
      this.game_money_list = JSON.parse(localStorage.getItem('gameEditPrice_Liuhe'));
    }
    localStorage.setItem("gameDefaultPrice_Liuhe", JSON.stringify(this.game_default_money_list))
    localStorage.setItem("gameEditPrice_Liuhe", JSON.stringify(this.game_money_list))
    this.getRoomInfo()
    this.getGameList()
    this.getMoneyInfo()
    this.getSequenceNum()
  },
  methods: {
    formatDate,
    back() {
      window.history.go(-1)
    },
    async showTost(type, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    clickNaTab(type, path) {
      if (path.length > 0) {
        this.$router.push({
          path: path,
        })
        return;
      }
      this.nav_type = type
      if(type === 3) {
        // 游戏记录
        this.trend_page = 1
        this.getTrendList()
      }else if(type === 6) {
        // 开奖验证
        this.history_page = 1
        this.getHistoryList();
      }else if(type === 10) {
        this.initBetJson()
      }
    },
    initBetJson() {
      this.bet_page = 1
      this.getBetJson()
    },
    // 获取所有游戏列表
    getGameList() {
      this.$apiFun
        .post('/api/game/youxiList', {
          type: this.game_video,
          page: 1,
          per_page: 100
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            const list = Object.values(res.data)
            const text_arr = []
            list.forEach((item) => {
              text_arr.push(item.name)
            })
            const translate_arr = await translateText(text_arr)
            translate_arr.forEach((item, index) => {
              list[index].name = item
            })
            this.game_list = list

          }
        })
        .catch(res => {
        });
    },
    getRoomInfo() {
      this.$apiFun
        .post('/api/game/index', {
          video: this.game_video,
          room: this.room
        })
        .then(async (res) => {
          if (res.code !== 200) {
            // this.showTost(0, res.data.message);
            if(res.data.message) {
              this.ErrorMsg(res.data.message)
            }
          }
          if (res.code === 200) {
            this.room_info = res.data
            const text_arr = []
            this.room_info.chat_info.forEach((item) => {
              text_arr.push(item.content)
            })
            const translate_arr = await translateText(text_arr)
            translate_arr.forEach((item, index) => {
              this.room_info.chat_info[index].content = item
            })
            this.chat_list = this.room_info.chat_info
            const val = await translateText([this.room_info.youxi.name])
            this.title = val[0]
            this.setIntervalStatus()
          }
          this.getMsg()
          clearInterval(this.timerInter)
          this.timerInter = setInterval(() => {
            if (!this.loadingMsg) this.getMsg();
          }, 1500);
        })
        .catch(res => {
        });
    },
    // 余额不足不能进入房间
    async ErrorMsg(msg) {
      const message = await translateText([msg]);
      let that = this;
      that.$dialog
        .alert({
          title: that.$t('错误提示'),
          message: message[0],
        })
        .then(() => {
          this.back()
        })
    },
    getSequenceNum() {
      this.$apiFun
        .post('/api/game/ajaxSequencenum', {
          video_both: this.game_video,
          sequencenum_span: ''
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            if(res.data && Object.keys(res.data).length > 0) {
              this.stopTimer()
              const info =  res.data
              info.outcome_arr = info.outcome.split('-')

              this.sequence_info = info


              const starttime = parseInt(info.sealing_plate)
              const fwq_time = parseInt(info.fwq_time)

              var elapsed = Math.floor((Date.now() -  Date.now()) / 1000);
              const nowtime = fwq_time + elapsed;

              // 剩余秒数
              const time = starttime - nowtime;
              this.totalSeconds = time
              this.startCountdown()
            }else {
              setTimeout(() => {
                this.getSequenceNum()
              }, 3000);
            }

          }
        })
        .catch(res => {
        });
    },

    async getMsg() {
      if (this.loadingMsg) return; // 防止并发请求
      this.loadingMsg = true;

      try {
        const res = await this.$apiFun.post('/api/game/ajaxchat', {
          video_both: this.game_video,
          room: this.room,
          lastId: this.room_info.lastId
        });

        if (res.code !== 200) {
          this.showTost(0, res.data.message);
          return;
        }

        const list = res.data.list || [];
        if (list.length === 0) {
          this.loadingMsg = false;
          return;
        }

        // 翻译内容
        const text_arr = list.map(i => i.content || '');
        const translate_arr = await translateText(text_arr);

        list.forEach((item, index) => {
          if (translate_arr[index]) item.content = translate_arr[index];
        });
        this.room_info.lastId = list[list.length - 1].id;
        // 合并并滚动
        this.chat_list = this.mergeArrayWithoutDup(this.chat_list, list);
        this.scrollMsgBox();

      } catch (err) {
        console.error('getMsg error:', err);
      } finally {
        this.loadingMsg = false;
      }
    },
    getTrendList() {
      this.loading_trend = true;
      this.$parent.showLoading()
      this.$apiFun
        .post('/api/game/trend', {
          room: this.room,
          type: this.game_video,
          per_page: this.page_size,
          page: this.trend_page
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            const list = res.data.list
            this.trend_total_page = res.data.total_pages > 0 ? res.data.total_pages : 1;
            list.forEach(item => {
              item.outcome_arr = item.outcome.split('-')
            })
            if(this.trend_page === 1) {
              this.trend_list = list
            }else {
              this.trend_list = [...this.trend_list, ...list]
            }
            this.trend_page++;
          }
          this.$parent.hideLoading();
          this.loading_trend = false;
        })
        .catch(res => {
          this.$parent.hideLoading();
          this.loading_trend = false;
        });
    },
    // 历史记录
    getHistoryList() {
      this.loading_history = true;

      this.$parent.showLoading()
      this.$apiFun
        .post('/api/game/trend', {
          room: this.room,
          type: this.game_video,
          per_page: this.page_size,
          page: this.history_page
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            const list = res.data.list
            this.history_total_page = res.data.total_pages > 0 ? res.data.total_pages : 1;
            list.forEach(item => {
              item.outcome_arr = item.outcome.split('-')
            })
            if(this.history_page === 1) {
              this.history_list = list
            }else {
              this.history_list = [...this.history_list, ...list]
            }
            this.history_page++;
          }
          this.$parent.hideLoading();
          this.loading_history = false;
        })
        .catch(res => {
          this.$parent.hideLoading();
          this.loading_history = false;

        });
    },
    // 游戏记录
    getBetJson() {

      this.loading_bet = true
      this.$parent.showLoading()
      this.$apiFun
        .post('/api/game/betsJson', {
          room: this.room,
          type: this.game_video,
          per_page: this.page_size,
          page: this.bet_page,
          status: this.other_nav_index, // 0-进行中 1-已结束
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            this.bet_info = res.data
            const list = res.data.list
            this.bet_total_page = res.data.total_pages > 0 ? res.data.total_pages : 1;
            list.forEach(item => {
              item.outcome_arr = item.outcome.split('-')
            })
            // 翻译内容
            const text_arr = list.map(i => i.content_t || '');
            const translate_arr = await translateText(text_arr);

            list.forEach((item, index) => {
              if (translate_arr[index]) item.content_t = translate_arr[index];
            });

            if(this.bet_page === 1) {
              this.bet_list = list
            }else {
              this.bet_list = [...this.bet_list, ...list]
            }
            this.bet_page++;
          }
          this.$parent.hideLoading();
          this.loading_bet = false
        })
        .catch(res => {
          this.$parent.hideLoading();
          this.loading_bet = false
        });
    },
    // 更新用户状态
    updateOnlineStatus() {
      this.$apiFun
        .post('/api/game/updateOnlineStatus', {
          location: this.title+'-'+(this.room === 'one' ? '初级房' : '中级房'),
        })
        .then(async (res) => {
          // if (res.code !== 200) {
          // this.showTost(0, res.data.message);
          // }
          // if (res.code === 200) {
          // }
        })
        .catch(res => {
        });
    },
    setIntervalStatus() {
      clearInterval(this.statusInterval)
      this.statusInterval = setInterval(()=> {
        this.updateOnlineStatus()
      }, 3000)
    },
    sendMessage() {

      if(this.send_val.length === 0) {
        this.showTost(0, '发送的消息不能为空');
        return;
      }
      if (this.isWithinTimeRange('19:56:30', '20:29:30')) {
        // 显示提示内容
        // this.showTost(0, `18:56～19:30 为维护时间`);
        this.showTost(0, `19:56:30～20:29:30 为维护时间`);
        return;
      }
      if (this.isWithinTimeRange('23:55:30', '00:05:00')) {
        // 显示提示内容
        this.showTost(0, `23:55:30～00:05:00 为维护时间`);
        return;
      }
      if(this.totalSeconds <= Number(this.room_info.youxi.qs_start_time)) {
        this.showTost(0, `本期已封盘`);
        return;
      }
      this.$parent.showLoading();
      this.$apiFun
        .post('/api/game/chooseChat', {
          video_both: this.game_video,
          room: this.room,
          data: this.send_val,
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            this.showTost(1, '发送成功');
            this.clearSendInput()
            this.nav_type = 0
            this.isPageModal = false;
            this.getMoneyInfo()
            setTimeout(() => {
              this.scrollMsgBox()
            }, 1000)
          }
          this.$parent.hideLoading()
        })
        .catch(res => {
          this.$parent.hideLoading()
        });
    },
    clearSendInput() {
      this.send_val = ''
      this.game_type_val = []
      this.game_type_price = 0
      this.num_val = ''
    },
    sendBetMsg(){
      if(this.game_type_val.length === 0) {
        this.showTost(0, '请选择玩法');
        return false;
      }
      const price = Number(this.num_val) > 0 ? Number(this.num_val) : Number(this.game_type_price)
      if(price <= 0) {
        this.showTost(0, '请选择金额');
        return false;
      }
      let val = ''
      this.game_type_val.forEach((item, index) => {
        val += (index > 0 ? ' ' : '') + item + (this.isNumber(item) ? '.' : '') + price
      })

      this.send_val = val

      this.sendMessage()
    },
    // 合并两个数组并去重
    mergeArrayWithoutDup(arr1, arr2) {
      return arr1.concat(arr2.filter(item2 => !arr1.some(item1 => item1.id === item2.id)));
    },
    // 获取当前越南时间（UTC+7）
    getVietnamTime() {
      const now = new Date();
      // 将当前时间转换为 UTC 毫秒
      // const utc = now.getTime() + now.getTimezoneOffset() * 60000;
      // 再加上 7 小时偏移（越南时间）
      // return new Date(utc + 7 * 60 * 60 * 1000);
      return now;
    },
    isInVietnamMaintenanceTime() {
      const vnTime = this.getVietnamTime();
      const hours = vnTime.getHours();
      const minutes = vnTime.getMinutes();

      // 只在 18 点 56 分到 19 点 30 分之间为 true
      if (hours === 18 && minutes >= 56) return true;
      if (hours === 19 && minutes < 30) return true;

      return false;
    },
    isWithinTimeRange(startTime, endTime) {
      // 获取当前时间
      const now = new Date();

      // 获取当前的小时、分钟和秒
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const currentSecond = now.getSeconds();

      // 将当前时间转换为字符串格式 "HH:MM:SS"
      const currentFormattedTime = `${currentHour.toString().padStart(2, '0')}:${currentMinute.toString().padStart(2, '0')}:${currentSecond.toString().padStart(2, '0')}`;

      // 将开始和结束时间也转换为字符串格式 "HH:MM:SS"
      const formattedStartTime = startTime.replace(/:/g, ''); // 移除冒号以方便比较
      const formattedEndTime = endTime.replace(/:/g, ''); // 移除冒号以方便比较
      const formattedCurrentTime = currentFormattedTime.replace(/:/g, ''); // 移除冒号以方便比较

      // 比较当前时间是否在开始时间和结束时间之间
      return formattedCurrentTime >= formattedStartTime && formattedCurrentTime <= formattedEndTime;
    },
    // 判断是否为数字
    isNumber(value) {
      return !isNaN(Number(value)) && value !== '';
    },
    // 判断属性
    getNumText(item){
      var she = ['1', '13', '25', '37', '49'];
      if (she.indexOf(item) > -1) return this.$t('蛇');

      var long = ['2', '14', '26', '38'];
      if (long.indexOf(item) > -1) return this.$t('龙');

      var tu = ['3', '15', '27', '39'];
      if (tu.indexOf(item) > -1) return this.$t('兔');

      var hu = ['4', '16', '28', '40'];
      if (hu.indexOf(item) > -1) return this.$t('虎');

      var niu = ['5', '17', '29', '41'];
      if (niu.indexOf(item) > -1) return this.$t('牛');

      var shu = ['6', '18', '30', '42'];
      if (shu.indexOf(item) > -1) return this.$t('鼠');

      var zhu = ['7', '19', '31', '43'];
      if (zhu.indexOf(item) > -1) return this.$t('猪');

      var gou = ['8', '20', '32', '44'];
      if (gou.indexOf(item) > -1) return this.$t('狗');

      var ji = ['9', '21', '33', '45'];
      if (ji.indexOf(item) > -1) return this.$t('鸡');

      var hou = ['10', '22', '34', '46'];
      if (hou.indexOf(item) > -1) return this.$t('猴');

      var yang = ['11', '23', '35', '47'];
      if (yang.indexOf(item) > -1) return this.$t('羊');

      var ma = ['12', '24', '36', '48'];
      if (ma.indexOf(item) > -1) return this.$t('马');
    },
    getNumColor(item){
      const red = ['1','2','7','8','12','13','18','19','23','24','29','30','34','35','40','45','46'];
      const blue = ['3','4','9','10','14','15','20','25','26','31','36','37','41','42','47','48'];
      const green = ['5','6','11','16','17','21','22','27','28','32','33','38','39','43','44','49'];
      if(red.includes(item)){
        return 'red-bg';
      }else if(blue.includes(item)){
        return 'blue-bg';
      }else {
        return 'green-bg';
      }
      // else{
      //   return 'gray-bg';
      // }
    },
    // 红波、绿波、蓝波
    getNumWave(item){
      const red = ['1','2','7','8','12','13','18','19','23','24','29','30','34','35','40','45','46'];
      const blue = ['3','4','9','10','14','15','20','25','26','31','36','37','41','42','47','48'];
      const green = ['5','6','11','16','17','21','22','27','28','32','33','38','39','43','44','49'];
      if(red.includes(item)){
        return this.$t('红波');
      }else if(blue.includes(item)){
        return this.$t('蓝波');
      }else {
        return this.$t('绿波');
      }
    },
    getMoneyInfo() {
      this.$apiFun
        .get('/api/game/chooseUser', {
          video: this.game_video,
          room: this.room
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.message);
          }
          if (res.code === 200) {
            this.money = res.data.balance
          }
        })
        .catch(res => {
        });
    },

    startCountdown() {
      this.updateDisplay() // 立即顯示初始時間
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.totalSeconds > 0) {
          this.totalSeconds--
          const h = Math.floor(this.totalSeconds / 3600)
          const m = Math.floor((this.totalSeconds % 3600) / 60)
          const s = this.totalSeconds % 60

          this.hours = String(h).padStart(2, '0')
          this.minute = String(m).padStart(2, '0')
          this.second = String(s).padStart(2, '0')
        } else {
          clearInterval(this.timer)
          this.timer = null
          this.startTimer()

        }
      }, 1000)
    },


    startTimer() {
      if (this.time_interval) {
        clearInterval(this.time_interval)
      }
      this.time_interval = setInterval(() => {
        this.getSequenceNum()
      }, 6000)
    },
    stopTimer() {
      if (this.time_interval) {
        clearInterval(this.time_interval)
        this.time_interval = null
      }
    },
    updateDisplay() {
    },
    toggleArrowMore() {
      this.isDropList = !this.isDropList;
      if(this.isDropList) {
        this.trend_page = 1
        this.getTrendList()
      }
    },
    selectGameType(type) {
      if(this.game_type_val.includes(type)) {
        this.game_type_val =  this.game_type_val.filter(item => item !== type)
      }else {
        this.game_type_val.push(type)
      }
    },
    // 恢复默认
    setDefaultPrice() {
      localStorage.setItem("gameEditPrice_Liuhe", JSON.stringify(this.game_default_money_list))
      this.game_money_list = this.game_default_money_list
      this.showTost(1, '恢复成功')
    },
    setAllPrice() {
      const invalidItems = this.game_money_list.filter(item => item === '' || item === null || item === undefined || item === 0 || item === "0");
      if (invalidItems.length > 0) {
        this.showTost(0, '价格不能为空值或0')
        return false;
      }
      const seen = new Set();
      const duplicates = new Set();

      this.game_money_list.forEach(item => {
        if (seen.has(item)) {
          duplicates.add(item);
        } else {
          seen.add(item);
        }
      });

      if (duplicates.size > 0) {
        this.showTost(0, '价格不能有重复')
        return false;
      }
      localStorage.setItem("gameEditPrice_Liuhe", JSON.stringify(this.game_money_list))
      this.showEditMoney = false
    },

    scrollMsgBox() {
      this.$nextTick(() => {
        // 👇 滚动到底部
        const el = this.$refs.scrollContainer;
        if(el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.timerInter)
    clearInterval(this.statusInterval)
    this.stopTimer();
  },
  deactivated() {
    clearInterval(this.timer)
    clearInterval(this.timerInter)
    clearInterval(this.statusInterval)
    this.stopTimer();
  }
}
</script>

<style scoped lang="scss">
.game-room-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 1;
  overflow: hidden;
  bottom: 0;
  bottom: env(safe-area-inset-bottom, 0); /* 兼容刘海/手势栏 */
  background-color: #000000;
  background-image: url("/static/image/new/game/game-room-bg.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  color: #fff;
  box-sizing: border-box;
  font-family: PingFang SC;
  .head-bg-img {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;

  }
  .green-bg {
    color: #fff !important;
    background: linear-gradient( 180deg, #00E137 0%, #00C400 47%, #00DC00 100%) !important;
  }
  .red-bg {
    color: #fff !important;
    background: linear-gradient( 180deg, #FF5861 0%, #EC2627 47%, #FB3E38 100%) !important;
  }
  .blue-bg {
    color: #fff !important;
    background: linear-gradient( 180deg, #99CFFF 0%, #7D9BFD 47%, #388BF6 100%) !important;
  }
  .gray-bg {
    color: #007AFF !important;
    background: #fff !important;
  }
  .red-color {
    color: #EF2B29 !important;
  }
  .blue-color {
    color: #4B90F8 !important;
  }
  .head-area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .3rem;

    .leftImg {
      width: .5rem;
      text-align: right;
      transform: rotate(180deg);
      margin-bottom: .1rem;
    }

    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }

    .head_text {
      font-family: PingFang SC;
      font-weight: 600;
      color: #fff;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      .title {
        max-width: 50%;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 0.48rem;
      }
    }

    .right_menu {
      font-size: 0.29rem;
      font-family: PingFang SC;
      color: #fff;
      flex-shrink: 0;
      text-align: right;
      display: flex;
      align-items: center;


    }
  }

  .lottery-box-bg {
    border-radius: .24rem;
    margin: 0.2rem .4rem 0;
    //padding: .02rem;
    //border: 1px solid;
    //border-image-source: linear-gradient(97.24deg, #363C71 0%, #666666 97.9%);

  }

  .lottery-box {
    background: rgba(30, 34, 35, 0.4);
    border-radius: .24rem;
    overflow: hidden;
    position: relative;
    padding: .32rem .4rem;
    backdrop-filter: blur(8px);
    border: 1px solid #666666;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.32rem;
      //padding-left: .2rem;
      text-align: center;

      .top-left {
        flex-shrink: 0;
        .lottery-period {
        }
      }

      .top-right {
        display: flex;
        align-items: center;

        .lottery-num {
          font-size: .37rem;
          margin-right: .21rem;
        }

        .brand-status {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          height: 0.53rem;
          line-height: 0.53rem;
          background: #007AFF;
          border-radius: .27rem;
          padding: 0 .11rem;
          font-size: 0.24rem;

          .icon {
            width: 0.37rem;
            margin-right: .13rem;
          }
        }
      }
    }

    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 0.21rem;
      .count-down {
        display: flex;
        align-items: center;

        .hours-box, .minute-box, .second-box {
          width: 0.8rem;
          height: 1.01rem;
          margin-right: 0.21rem;
          background-size: 100% 100%;
          font-family: Gilroy, Gilroy;
          font-size: 0.43rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .hours-box {
          background-image: url("/static/image/new/game/minute-bg.png");
        }
        .minute-box {
          background-image: url("/static/image/new/game/minute-bg.png");
        }

        .second-box {
          background-image: url("/static/image/new/game/second-bg.png");
        }
        .status {
          color: #C4C4C4;
          font-size: .32rem;
          margin-left: .1rem;
        }

      }

      .user-money {
        font-size: .32rem;
        text-align: left;
        padding-right: .2rem;
        .money {
          background: linear-gradient(180deg, #FEC253 16.67%, #664201 119.05%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-size: .53rem;
          font-weight: bold;
          font-family: Gilroy;
          margin-top: .1rem;
        }
      }


    }
  }
  .lottery-results-box {
    background: rgba(25, 27, 28, 0.5);
    backdrop-filter: blur(3px);
    margin-top: .26rem;
    padding: .36rem .43rem .1rem;
    .results-title {
      display: flex;
      align-items: center;
      justify-content: space-between;

    }
    .lottery-results {
      display: flex;
      justify-content: center;
      margin-top: .43rem;
      .symbol {
        font-size: .36rem;
        margin: .3rem .08rem;
      }
      .num-item {
        flex-shrink: 0;
        width: .82rem;
        margin: 0 .12rem;
        .num {
          width: 100%;
          height: .82rem;
          line-height: .82rem;
          text-align: center;
          font-size: 0.43rem;
          border-radius: 50%;

        }
        .num-type {
          font-size: .32rem;
          margin-top: .04rem;
          text-align: center;
        }
      }

    }

  }
  .nav-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow-x: auto;
    margin: .3rem 0 0;
    padding: .21rem 0;

    .nav-item {
      height: 0.69rem;
      display: flex;
      align-items: center;
      padding: 0 .4rem;
      flex-shrink: 0;
      border-radius: .45rem;
      font-size: 0.32rem;

      &.active {
        background: linear-gradient(to right, #007AFF, #007AFF);
      }

    }
  }

  .content {
    flex: 1;
    overflow: auto;
    position: relative;
    .msg-container {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      position: relative;
      .msg-list {
        padding: .53rem .4rem;
        flex: 1;
        overflow: auto;
        .msg-item {
          display: flex;
          align-items: self-start;
          margin-bottom: .53rem;
          .left {
            .avatar {
              width: 0.91rem;
              height: 0.91rem;
              border-radius: 50%;
              overflow: hidden;
            }
          }

          .right {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 0 .21rem;
            box-sizing: border-box;
            .msg-name {
              font-size: .37rem;
              margin-bottom: .2rem;
              color: #3997FF;
              display: flex;
              align-items: center;
            }
            .vip-box {
              background: #84E5FE;
              font-size: .25rem;
              display: flex;
              align-items: center;
              margin: 0 .2rem;
              border-radius: .2rem;
              padding-right: .15rem;
              color: #000;
              font-weight: bold;
              .vip-icon {
                width: 0.4rem;
                margin-left: 0rem;
                margin-right: .1rem;
              }
            }

            .msg-content {
              max-width: 100%;
              background: #1F2425;
              padding: 0.27rem .3rem;
              border-radius: .16rem;
              font-size: 0.32rem;
              display: inline-block;
              .msg-time {
                margin-bottom: .27rem;
              }
              .msg-text {
                margin-bottom: .1rem;
                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }

          &.self-msg-item {
            flex-direction: row-reverse;
            text-align: left;
            .right {
              display: flex;
              align-items: flex-end;
              justify-content: flex-end;
            }
            .msg-name {
              flex-direction: row-reverse;
            }
          }
        }
      }
    }
    .game-type-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      padding: 0rem 0 .32rem;
      box-sizing: border-box;
      &.game-type-container-modal {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 11;
        height: 60vh;
        background: #000;
      }
      .game-type-main {
        flex: 1;
        overflow: hidden;
        display: flex;
        align-items: center;
        .game-type-nav {
          background: #23282B;
          height: 100%;
          overflow: auto;
          width: 2.35rem;
          .nav-item {
            height: 1.39rem;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            font-size: 0.32rem;
            font-weight: bold;
            text-align: center;
            padding: 0 .1rem;
            &.active {
              background: linear-gradient(37.45347684120163deg, #1284FF 0%, #94C6FE 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              font-weight: bold;
              &::after {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                width: 0.11rem;
                background: linear-gradient(to bottom, #007AFF, #5BA9FF);
                border-top-right-radius: .2rem;
                border-bottom-right-radius: .2rem;
              }
            }

          }
        }
        .game-type-content {
          height: 100%;
          overflow: auto;
          flex: 1;
          padding: 0 .27rem;
          .game-num-list {
            width: 100%;
            padding-top: .1rem;
            .game-num-title {
              font-size: 0.32rem;
              margin-bottom: .27rem;
            }
            .game-num-row {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              width: 100%;
              margin-bottom: .33rem;
              .game-num {
                width: 2.16rem;
                height: 1.1rem;
                background: #23282B;
                flex-shrink: 0;
                margin-right: .27rem;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                flex-direction: column;
                margin-bottom: .2rem;
                font-size: 0.32rem;
                border-radius: 0.53rem;
                border: 1px solid #1E479B;
                box-sizing: border-box;
                &:nth-child(3n+3) {
                  margin-right: 0;
                }
                .value {
                  font-size: 0.3rem;
                  margin-top: .08rem;
                  color: #8F9394;
                }
                &.active {
                  background: linear-gradient(to right, #2C6EF6, #6094FF 100%);
                  color: #fff;
                  .value {
                    color: #fff;
                  }
                }
              }
            }
          }
        }
      }
      .game-type-num {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #1F2425;
        padding: .46rem .4rem 0;

        .select-num-box {
          width: 4.75rem;
          margin-right: .27rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border: 1px solid #1E479B;
          background: #23282B;
          height: .8rem;
          border-radius: .5rem;
          .num {
            width: calc(100% / 4);
            height: 100%;
            //font-size: 0.43rem;
            color: #B2B2B2;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            font-size: .37rem;
            &.active {
              background: #2C6EF6;
              color: #fff;
              border-radius: .5rem;
            }
          }
        }
        .edit-btn {
          width: 0.43rem;
          flex-shrink: 0;
        }
        .send-input {
          flex: 1;
          border: 1px solid #1E479B;
          height: .8rem;
          border-radius: .5rem;
          padding: 0 .26rem;
          background: #23282B;

          input {
            font-size: .32rem;
            outline: none;
            border: none;
            background: transparent;
            height: 100%;
            width: 100%;
            &::-webkit-input-placeholder {
              color: #B2B2B2;

            }
          }
        }
      }
      .game-type-btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: .32rem .37rem 0;
        .submit-tips {
          border: 1px solid #1E479B;
          background: #23282B;
          height: .8rem;
          line-height: .8rem;
          border-radius: .5rem;
          font-size: 0.25rem;
          flex: 1;
          text-align: center;
          span {
            margin-top: 0.03rem;
          }

        }
        .btn {
          height: .8rem;
          background: linear-gradient(to right, #2C6EF6, #6094FF 100%);
          margin-left: .1rem;
          box-shadow: 0 0.08rem 0.1rem 0 rgba(44, 110, 246, 0.30);
          border-radius: .5rem;
        }
        .clean-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 .25rem;
          font-size: 0.37rem;
          background: #23282B;
          border: 1px solid #1E479B;
          box-sizing: border-box;
          .del-icon {
            width: 0.48rem;
          }
        }
        .submit-btn {
          padding: 0 .25rem;
          font-size: 0.32rem;
          line-height: 0.48rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

        }
      }
    }

    .record-container {
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .table-head {
        height: 0.88rem;
        flex-shrink: 0;
        background: #1E2223;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .2rem;
        font-size: 0.32rem;
        color: #8F9394;
        text-align: center;
        .td {
          width: 56%;
          &:first-child {
            width: 20%;
          }
          &:last-child {
            width: 24%;
          }
        }
      }

      .recode-table {
        flex: 1;
        overflow: auto;
        .table-list {
          .tr {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 .2rem;
            height: 1.5rem;
            text-align: center;
            border-bottom: 1px solid #333333;
            .td {
              font-size: 0.27rem;
              width: 56%;
              &:first-child {
                width: 20%;
              }
              &:last-child {
                width: 24%;
              }
            }
            .sequencenum {
              margin-bottom: .1rem;
              font-size: 0.27rem;
            }
            .num-box {
              display: flex;
              justify-content: center;
              .num-item {
                margin: 0 .1rem;
                width: .5rem;
                flex-shrink: 0;
                box-sizing: border-box;
                .num {
                  width: 100%;
                  height: .5rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 50%;
                  font-size: .27rem;
                }
                .num-type {
                  font-size: .27rem;
                  margin-top: .04rem;
                  text-align: center;
                }
              }
              .symbol {
                font-size: .3rem;
                margin: .2rem .08rem;
              }

            }
            .last-text {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .text {
                width: 33%;
                font-size: .27rem;
                display: flex;
                align-items: center;
                justify-content: center;
                .num {
                  width: .55rem;
                  height: .55rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 50%;
                  flex-shrink: 0;
                  font-size: .22rem;
                }
              }
            }

          }
        }

      }

    }
    .history-container {
      height: 100%;
      display: flex;
      flex-direction: column;
      .history-list {
        padding: 0 .4rem;
        .history-item {
          border-bottom: 1px solid #333333;
          padding: .46rem 0;
          .item-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .item-head {
              * {
                font-size: .32rem;
              }
            }
          }
          .num-box {
            display: flex;
            justify-content: center;
            margin-top: .3rem;
            .num-item {
              margin: 0 .12rem;
              width: .82rem;
              .num {
                flex-shrink: 0;
                width: 100%;
                height: .82rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.43rem;
                border-radius: 50%;
              }
              .num-type {
                font-size: .27rem;
                margin-top: .15rem;
                text-align: center;
              }
            }
            .symbol {
              font-size: .36rem;
              margin: .3rem .08rem;
            }

          }
        }
      }


    }
    .other-container {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: .42rem .3rem;
      overflow: hidden;
      box-sizing: border-box;
      .nav-type-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #23282B;
        width: 5.5rem;
        border-radius: 1rem;
        .item {
          width: 50%;
          padding: 0 .1rem;
          color: #929697;
          font-size: 0.37rem;
          height: .91rem;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          border-radius: 1rem;

          &.active {
            background: #007AFF;
            color: #fff;
          }
        }
      }
      .type-list-container {
        flex: 1;
        width: 100%;
        overflow: auto;
        position: relative;
      }
      .type-list {
        width: 100%;
        padding-top: .53rem;
        .list-item {
          margin-bottom: .3rem;
          border-radius: .27rem;
          overflow: hidden;
          background: #1F2425;
          border: 0.03rem solid;
          border-image: linear-gradient(136deg, rgba(51, 51, 51, 1), rgba(100, 100, 100, 1)) 0.03 0.03;
          .item-head {
            height: 0.85rem;
            background: linear-gradient( 91deg, #007AFF 0%, #50A4FF 100%);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 .53rem;
            font-size: 0.37rem;
            .name {
              font-weight: 600;
            }
          }
          .item-content {
            padding: 0 .27rem;
            color: #8F9394;
            .table-title {
              font-size: 0.37rem;
              height: .96rem;
              line-height: .96rem;
            }
            .table-list {
              width: 100%;
              border: 0.03rem solid #4A4A4A;

              .tr {
                display: flex;
                align-items: center;
                text-align: center;
                border-bottom: 0.03rem solid #4A4A4A;
                color: #007AFF;
                .td {
                  width: 33.3%;
                  height: .7rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-right: 0.03rem solid #4A4A4A;
                  font-size: 0.32rem;
                  &:last-child {
                    border: none;
                  }
                }
                &:last-child {
                  border: none;
                  .td:first-child {
                    width: 66.6%;
                    font-size: .27rem;
                    color: #9C9C9C;
                  }
                }
              }
              .head-tr {
                background: #48485a;
                color: #B9B9B9;
              }
            }
            .table-foot {
              font-size: 0.32rem;
              height: .93rem;
              line-height: .93rem;
              display: flex;
              align-items: center;
              justify-content: space-between;

            }
          }
        }
      }
      .empy-content {
        padding: .6rem 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #929697;
        .icon {
          width: 3.49rem;
        }
      }
    }
    .list_drop_box {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      font-size: 0.32rem;
      .table-head {
        background: #1E2223;
        height: .88rem;
        display: flex;
        align-items: center;
        color: #8F9394;
        padding: 0 .2rem;
        .td {
          width: 25%;
          text-align: center;
        }
      }
      .recode-table {
        flex: 1;
        overflow: auto;
        .tr {
          display: flex;
          align-items: center;
          height: 1.1rem;
          padding: 0 .2rem;
          .td {
            width: 25%;
            text-align: center;
            &:nth-child(2) {
              width: 50%;
            }
            .num-box {
              display: flex;
              align-items: center;
              justify-content: center;
              .num {
                width: .62rem;
                height: .62rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                margin: 0 .1rem;
              }
            }
            .sum-info {
              display: flex;
              align-items: center;
              justify-content: space-around;
              padding: 0 .2rem;
            }
          }
        }
      }
    }
  }

  .footer {
    background: #1F2425;
    padding: .43rem .4rem;

    .bet-box {
      display: flex;
      align-items: center;
      font-family: PingFang SC, PingFang SC;
      .send-more {
        font-size: .59rem;
        margin-right: .27rem;
      }
      .bet-input {
        flex: 1;
        height: .8rem;
        background: #000000;
        border-radius: .11rem;
        padding: 0 .27rem;
        input {
          width: 100%;
          height: 100%;
          outline: none;
          border: none;
          background: none;
        }
      }

      .bet-btn {
        min-width: 1.87rem;
        height: .8rem;
        padding: 0 .2rem;
        background: #2C6EF6;
        border-radius: .4rem;
        color: #F1F1F1;
        font-size: 0.37rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: .27rem;
      }
    }
  }
  .overlay-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, .6);
    z-index: 8;
  }

  .edit-money-popup {
    background: #1f2425;
    padding-bottom: 1.1rem;
    .title-box {
      background: #2C6EF6;
      height: 1.01rem;
      line-height: 1.01rem;
      text-align: center;
      position: relative;
      font-size: 0.48rem;
      .arrow-btn {
        position: absolute;
        top: 50%;
        right: .43rem;
        transform: translateY(-50%);
        width: 0.37rem;
      }
    }
    .price-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      box-sizing: border-box;
      padding: .37rem .2rem 0;

      .price-item {
        margin: 0.055rem;
        width: 3.01rem;
        height: 0.91rem;
        border-radius: .11rem;
        box-sizing: border-box;
        overflow: hidden;
        padding: 0 .2rem;
        background: #292F32;
        input {
          width: 100%;
          height: 100%;
          outline: none;
          border: none;
          background: none;
          text-align: center;
          font-size: 0.48rem;
        }
      }
    }
    .btn-box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: .48rem;
      .btn {
        min-width: 2.99rem;
        padding: 0 .2rem;
        height: 1.01rem;
        line-height: 1.01rem;
        border-radius: .13rem;
        font-size: 0.42rem;
        text-align: center;
        background: linear-gradient(to right, #2C6EF6 60%, #6094FF 100%);
        &.default-btn {
          background: #40484B;
          margin-right: 0.8rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Liuhe/room.vue